import { render, staticRenderFns } from "./DesktopMenuSecondLevel.vue?vue&type=template&id=9b5485a4&"
import script from "./DesktopMenuSecondLevel.vue?vue&type=script&lang=js&"
export * from "./DesktopMenuSecondLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports